import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, ref, } from 'vue';
import CurTarget from './components/curTarget.vue';
import AnnualTarget from './components/annualTarget.vue';
import { useRouter, } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const curSHow = ref<boolean>(true);
const changeShow = (val:boolean) => {
  curSHow.value = val;
};


return (_ctx: any,_cache: any) => {
  return (curSHow.value )
    ? (_openBlock(), _createBlock(CurTarget, {
        key: 0,
        onIsShow: changeShow
      }))
    : (_openBlock(), _createBlock(AnnualTarget, {
        key: 1,
        onIsShow: changeShow
      }))
}
}

})